// Make sure to prefix the mutation names with the module to avoid collisions
export const FORM_SET_FORM = 'formSetForm'
export const FORM_SET_FORMS = 'formSetForms'
export const FORM_SET_FORM_SUBMISSIONS = 'formSetFormSubmissions'
export const FORM_SET_EDITABLE_MEMBERSHIP_FORMS = 'formSetEditableMembershipForms'
export const FORM_SET_HIDDEN_MEMBERSHIP_FORMS = 'formSetHiddenMembershipForms'
export const FORM_ADD_SELECTED_FORM_SUBMISSION = 'formAddSelectedFormSubmission'
export const FORM_REMOVE_SELECTED_FORM_SUBMISSION = 'formRemoveSelectedFormSubmission'
export const FORM_SELECT_ALL_FORM_SUBMISSIONS = 'formSelectAllFormSubmissions'
export const FORM_RESET_SELECTED_FORM_SUBMISSIONS = 'formResetSelectedFormSubmissions'
export const FORMS_STOP_EXPORTING_SUBMISSIONS = 'formStopExportingSubmissions'
export const FORMS_START_EXPORTING_SUBMISSIONS = 'formStartExportingSubmissions'